<template>

    <core-Form ref="form" :model="'form'" :submit="consultaChave">
        <b-row>
            <b-col xl="12" md="12" sm="12">
                <b-form-group label="Conta">
                    <core-conta ref="contaDebito" v-model="form.ContaDebito"></core-conta>
                </b-form-group>
            </b-col>
            <b-col xl="4" md="5" sm="3">
                <b-form-group label="Chave">
                    <b-input v-model="form.chave" @input="limparConsulta" :maxlength="77" :readonly="readonly" required />
                </b-form-group>
            </b-col>
            <b-col xl="2" md="2" sm="3" v-if="consulta.chave">
                <b-form-group label="Tipo Chave">
                    <b-form-select v-model="consulta.tipoChave" disabled :options="$api.Arrays.TipoChavePix" />
                </b-form-group>
            </b-col>

        </b-row>

        <b-btn type="submit" v-if="!readonly" variant="primary">Consulta</b-btn>

        <br /><br />

        <span v-if="consulta.chave">
            <b-row>
                <b-col xl="4" lg="4" md="4" sm="6" xs="6">
                    <b-form-group label="Nome Correntista">
                        <b-input v-model="consulta.nomeCorrentista" disabled></b-input>
                    </b-form-group>
                </b-col>
                <b-col xl="4" lg="4" md="4" sm="6" xs="6">
                    <b-form-group label="Tipo Pessoa">
                        <b-form-select v-model="consulta.tipoPessoa" :options="$api.Arrays.TiposPessoa" disabled />
                    </b-form-group>
                </b-col>
                <b-col xl="4" lg="4" md="4" sm="6" xs="6">
                    <b-form-group label="Documento Federal">
                        <b-input v-model="consulta.documentoFederal" disabled></b-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col xl="4" lg="4" md="4" sm="6" xs="6">
                    <b-form-group label="Conta">
                        <b-input v-model="consulta.conta.conta" disabled></b-input>
                    </b-form-group>
                </b-col>
                <b-col xl="4" lg="4" md="4" sm="6" xs="6">
                    <b-form-group label="Tipo Conta">
                        <b-form-select v-model="consulta.conta.tipoConta" :options="$api.Arrays.TiposConta" disabled></b-form-select>
                    </b-form-group>
                </b-col>
                <b-col xl="4" lg="4" md="4" sm="6" xs="6">
                    <b-form-group label="Agência">
                        <b-input v-model="consulta.conta.agencia" disabled></b-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col xl="4" lg="4" md="4" sm="6" xs="6">
                    <b-form-group label="Número Banco">
                        <b-input v-model="consulta.banco.numero" disabled></b-input>
                    </b-form-group>
                </b-col>
                <b-col xl="4" lg="4" md="4" sm="6" xs="6">
                    <b-form-group label="Descrição Banco">
                        <b-input v-model="consulta.banco.descricao" disabled></b-input>
                    </b-form-group>
                </b-col>
                <b-col xl="4" lg="4" md="4" sm="6" xs="6">
                    <b-form-group label="ISPB Banco">
                        <b-input v-model="consulta.banco.ispb" disabled></b-input>
                    </b-form-group>
                </b-col>
            </b-row>
        </span>
    </core-Form>
</template>

<script>
    export default {
        props: {
            rastreada: {
                type: Boolean,
                default: false
            },
            contaDebito: {
                type: Object
            },
            leituraQRCode: {
                type: Object
            },
            wizard: {
                type: Object
            }
        },
        watch: {
            'leituraQRCode': function (val) {
                if (val.chave) {
                    this.readonly = true
                    this.form.chave = val.chave
                    this.consultaChave()
                } else {
                    this.readonly = false
                }
            }
        },
        data() {
            return {
                form: {
                    chave: null,
                    ContaDebito: {}
                },
                consulta: {},
                readonly: false,
            }
        },
        computed: {
            model: {
                get() {
                    var obj = this.value
                    return obj
                },
                set(value) {
                    this.$emit('input', value)
                }
            }
        },
        methods: {
            validaContaDebito() {
                return this.$refs.contaDebito.validate()
            },
            validate() {
                validaContaDebito();

                let formStatus = this.$api.UI.FormValidate(this.$refs.form)

                if (!formStatus) return formStatus

                if (this.rastreada && !this.consulta.ticket) {
                    this.$api.UI.ShowError('Erro', 'Obrigatório gerar ticket de consulta.')
                    return false
                } else return formStatus
            },
            limparConsulta() {
                this.consulta = {}
            },
            consultaChave() {
                let th = this
                if (this.rastreada) {
                    let dto = {
                        Chave: this.form.chave,
                        Agencia: this.contaDebito.agencia.numero,
                        AgenciaDigito: this.contaDebito.agencia.digito,
                        Conta: this.contaDebito.conta.numero,
                        ContaDigito: this.contaDebito.conta.digito,
                        ContaPgto: this.contaDebito.conta.contaPgto,
                        TipoConta: parseInt(this.contaDebito.conta.tipoConta)
                    }

                    this.$api.ContaChavePix.ConsultaRastreada(dto).then((response) => {
                        if (response) {
                            if (response.status && response.status === 404) {
                                th.$api.UI.ShowError('Erro', 'Chave não encontrada.')
                            } else if (response && response.sucesso === false) {
                                th.$api.UI.ShowError('Erro', response.mensagem)
                            } else if (th.$api.UI.PostAction(response)) {
                                th.consulta = response
                                th.consulta.documentoFederal = th.$api.UI.Format.DocumentoFederal(response.documentoFederal)
                                th.model = Object.assign({}, response)
                                if (this.wizard != null) {
                                    this.wizard.nextTab();
                                }
                            }
                        }
                    })
                } else {
                    let dto = {
                        Chave: this.form.chave,
                        Agencia: th.form.ContaDebito.agencia.numero,
                        AgenciaDigito: th.form.ContaDebito.agencia.digito,
                        Conta: th.form.ContaDebito.conta.numero,
                        ContaDigito: th.form.ContaDebito.conta.digito,
                        ContaPgto: th.form.ContaDebito.contaPagador,
                        TipoConta: th.form.ContaDebito.conta.tipoConta
                    }

                    this.$api.ContaChavePix.ConsultaChaveOnline(dto).then((response) => {
                        if (response.status && response.status === 404) {
                            th.$api.UI.ShowError('Erro', 'Chave não encontrada.')
                        } else if (response && response.sucesso === false) {
                            th.$api.UI.ShowError('Erro', response.mensagem)
                        } else if (th.$api.UI.PostAction(response)) {
                            th.consulta = response
                            th.consulta.documentoFederal = th.$api.UI.Format.DocumentoFederal(response.documentoFederal)
                        }
                    })
                }
            }
        }
    }

</script>
